module.exports = "/assets/466cf7c6ad5b14d55e7251e2f179324d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LI.png
// module id = 2704
// module chunks = 0